module.exports = __webpack_public_path__ + "h5/img/logo2.2a0d4702.png";